import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "./../../constants";
import {
  AssignDeliveryCompanyRequest,
  AssignDeliveryCompanyResponse
} from "./assignDeliveryCompany.types";

export const requestAssignDeliveryCompany = async ({
  orderId,
  deliveryCompanyId
}: AssignDeliveryCompanyRequest): Promise<AssignDeliveryCompanyResponse> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesOrders.Orders,
      orderId,
      ApiRoutesOrders.AssignDeliveryCompany,
      deliveryCompanyId
    )
  );
};
